import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { inject, onBeforeMount, Ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingStateEmitter',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const parentIsLoading = inject<Ref<boolean>>("loadingStateEmitterRef");

const updateLoadingState = () => {
  if (parentIsLoading) {
    parentIsLoading.value = props.isLoading;
  }
};

watch(
  () => props.isLoading,
  () => {
    updateLoadingState();
  },
);

onBeforeMount(() => {
  updateLoadingState();
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})